import { translation } from 'I18n/i18n'
import Modal from 'components/modal/modal'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { Colors } from 'styles/colors'
import './footer.scss'
export default function Footer() {
   const lang = useSelector((state: any) => state.languageReducer.language)
   const [open, setOpen] = useState(false)
   const pathname = window.location.pathname
   return (
      <>
         <Modal isOpen={open} onClose={() => setOpen(false)}>
            <div className='flex column'>
               <div
                  className='flex column'
                  style={{
                     padding: 20,
                     borderRadius: 20,
                     background: Colors.gris1,
                  }}
               >
                  <iframe width={900} height={1500} src='https://www.aptar.com'></iframe>
               </div>
               <br />
            </div>
         </Modal>
         <footer style={{ bottom: pathname === '/accueil/projets' ? '-300px' : 0 }}>
            {translation(lang, 'footer')}
            <b
               style={{
                  textDecoration: 'underline',
               }}
               onClick={() => setOpen(true)}
            >
               www.aptar.com
            </b>
         </footer>
      </>
   )
}
